<template>
	<div class="sf-table">
		<table class="qms-table">
			<tbody>
				<tr>
					<!-- 제품ID. -->
					<th>* {{ getMessage_('QWCC001538') }}</th>
					<td class="col-1">
						{{ selectedRow.pmcId }}
					</td>
					<th>{{ getMessage_('QWCC001009') }}</th>
					<td>
						{{ selectedRow.jvCpnyNm }}
					</td>
					<!-- HTWO판매일 -->
					<th>{{ getMessage_('QWCC001044') }}</th>
					<td>
						{{ selectedRow.erpSaleDd }}
					</td>
					<!-- 유효재고기간 -->
					<th>{{ getMessage_('QWCC002104') }}</th>
					<td class="col-1">
						<el-input v-model="selectedRow.eil" maxlength="3" :readonly="readOnlyAuth"></el-input>
					</td>
					
					<!-- 차수 -->
					<th>{{ getMessage_('QWCC002107') }}</th>
					<td class="col-1">
						{{ selectedRow.ipnNos }}
					</td>
					<th>{{ getMessage_('QWCC001814') }}</th>
					<td>
						{{ selectedRow.chgrNm }}
					</td>
				</tr>
				<tr>
					
					<!-- 차량VIN -->
					<th>{{ getMessage_('QWCC000960') }}</th>
					<td>
						{{ selectedRow.carVin }}
					</td>
					<th>{{ getMessage_('QWCC001541') }}</th>
					<td>
						{{ selectedRow.oemCpnyNm }}
					</td>
					<!-- OEM판매일 -->
					<th>{{ getMessage_('QWCC001012') }}</th>
					<td>
						{{ selectedRow.oemSaleDd }}
					</td>
					<!-- 검토일 -->
					<th>{{ getMessage_('QWCC002102') }}</th>
					<td>
						<el-date-picker
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="date"
							:value="selectedRow.wrntStrtDd"
							:readonly="readOnlyAuth"
							@input="changeWrntStrtDd"
						/>
					</td>
					

					<td colspan="2">
						<el-checkbox v-model="selectedRow.wrntStrtDdManualFlag" :disabled="readOnlyAuth">{{ getMessage_('QWCC002136') }}</el-checkbox>
					</td> 
					
					<th>{{ getMessage_('QWCC002108') }}</th>
					<td>
						{{ selectedRow.pmcChgrDt }}
					</td>
				</tr>
				<tr>
				
					<th>{{ getMessage_('QWCC002119') }}</th>
					<td class="col-1">
						<el-input v-model="selectedRow.licensePlate" maxlength="20" :readonly="readOnlyAuth"></el-input>
					</td>
					<th>{{ getMessage_('QWCC002120') }}</th>
					<td class="col-1">
						<el-input v-model="selectedRow.carrierName" maxlength="50" :readonly="readOnlyAuth"></el-input>
					</td>
					<th>{{ getMessage_('QWCC002122') }}</th>
					<td class="col-1">
						{{ selectedRow.vehicleRegDt }}
					</td>
					<th>{{ getMessage_('QWCC002123') }}</th>
					<td class="col-1">
						{{ selectedRow.carWrntStrtDd }}
					</td>

					<th>{{ getMessage_('QWCC001013') }}</th>
					<td>
						{{ selectedRow.custNm }}
					</td>
					
				</tr>
				
				
			</tbody>
		</table>
		<!-- 팝업추가 영역 -->
		<!-- <comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
		<user-popup-view ref="userPopupView" @SendData="sendData" :scrId="scrId" /> -->
	</div>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { UserPopupView, CompPopup },
	created() {
		this.setSelectedRow_({ key: 'pmcId', value: this.popupSearchParams.pmcId || '' });
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		
		setDisabled() {
			if (!this.selectedRow.pmcId || !this.selectedRow.ipnNos) return true;
			return !!this.selectedRow.csetDd;
		},
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSelectedRow(value, key) {
			this.setSelectedRow_({ key, value });
		},
		commInput({ key, value }) {
			this.setSelectedRow_({ key, value });
		},
		
		onUserPopup(userGbn) {
			this.$refs.userPopupView.open({ userGbn, userName: this.selectedRow[userGbn + 'Nm'] });
		},
		sendData(userData, userGbn) {
			this.setSelectedRow(userData.userId, userGbn + 'Id');
			this.setSelectedRow(userData.userName, userGbn + 'Nm');
		},
		onUserInPutKeyDown(userGbn) {
			this.setSelectedRow('', userGbn + 'Id');
		},
		changeWrntStrtDd(value){
			console.log("*********selectedRow", this.selectedRow);
			this.setSelectedRow(value, 'wrntStrtDd');
		}
	}
};
</script>
<style lang="scss">
.search-icon {
	top: 4px !important;
	right: 3px !important;
	font-size: 20px;
}
</style>
